// extracted by mini-css-extract-plugin
module.exports = {"FormHeader":"FormHeader_FormHeader__2clWr"};